import {phpBackendFormattedSeats, phpBackendFormattedGASeats} from '../utils/transformers';
import request from 'superagent';

export default  {
  // TODO, add validation
  buyTicket (basket, cb) {
    const formattedSeats = phpBackendFormattedSeats(basket.activeSeats);
    const formattedGASeats = phpBackendFormattedGASeats(basket.GASeats);
    const requestData = {};

    if (formattedSeats.length) {
      requestData.seats = formattedSeats;
    }
    if (formattedGASeats.length) {
      requestData.ga = formattedGASeats;
    }

    request
      .post(basket.urls.ism)
      .send(requestData)
      .end(function (err, res) {
        if (err || !res.ok) {
          cb(err, res.body);
        }
        else {
          cb(null, res.body);
        }
      });
  },

  unlockPriceType (payload, cb) {
    const {eventId, priceTypeId, password} = payload;
    const URI = `/checkout/ajax/validatePasswordPriceType.php?eventId=${eventId}&priceTypeId=${priceTypeId}`;
    request
      .post(URI)
      .send(`password=${password}`)
      .end((_, res) => { cb(res.body); });
  }
};



// WEBPACK FOOTER //
// ./frontend/react/api/basket.js